import { createBrowserRouter, Navigate, Outlet } from 'react-router-dom';
import App from '../App';
import Home from '../mound/Home';
import Login from '../mound/login';

const isAuthed = () => {
  return Boolean(localStorage.getItem('auth_token'));
};

const RequireAuth = () => {
  if (!isAuthed()) {
    return <Navigate to="/login" replace />;
  }
  return <Outlet />;
};

const router = createBrowserRouter([
  {
    element: <RequireAuth />,
    children: [
      {
        path: '/',
        element: <App />,
        children: [
          {
            path: '/',
            element: <Home />,
          },
        ],
      },
    ],
  },
  {
    path: '/login',
    element: <Login />,  
  },
  {
    path: '*',
    element: <Navigate to="/" replace />, 
  },
]);

export default router;